export const SortType = Object.freeze({
    REGISTERED_DATE: Symbol("registered_date"),
    LAST_ACTIVE: Symbol("last_active"),
    LAST_REPORT: Symbol("last_report"),
    LAST_TOUCHED: Symbol("last_touched"),
    MDM_ID: Symbol("mdm_id"),
    BATTERY_PERCENT: Symbol("battery_percent"),
    TOTAL_REPORTS: Symbol("total_reports"),
    ALPHABETICALLY: Symbol("alphabetically"),
    NETWORK_STATUS: Symbol("network_status"),
    POWER_STATE: Symbol("power_state"),
});
